webpackJsonp([3],{

/***/ "/MJf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/g6B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--3aQIo"};

/***/ }),

/***/ "0Bm2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--3Ee87"};

/***/ }),

/***/ "1TJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iKG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slds-icon-ellie-pop":"slds-slds-icon-ellie-pop--254Ct","slds-icon-ellie":"slds-slds-icon-ellie--3wQUF","slds-icon-eq":"slds-slds-icon-eq--3c6vS","slds-icon-strength-positive-load":"slds-slds-icon-strength-positive-load--2wU6J","slds-icon-strength-negative-load":"slds-slds-icon-strength-negative-load--1GEiz","slds-icon-trend-arrow":"slds-slds-icon-trend-arrow--3RoAI","slds-icon-trend-circle":"slds-slds-icon-trend-circle--20DSH","slds-icon-waffle-throb":"slds-slds-icon-waffle-throb--2uQJV","slds-click-global-action":"slds-slds-click-global-action--wDs_I","slds-icon-typing__dot-first":"slds-slds-icon-typing__dot-first--DIUMN","slds-icon-typing__dot-second":"slds-slds-icon-typing__dot-second--12imf","slds-icon-typing__dot-third":"slds-slds-icon-typing__dot-third--h0k6_","click-icon":"slds-click-icon--2j7CZ","click-favorites-icon":"slds-click-favorites-icon--RHhWa","ding":"slds-ding--1NeRO","bell":"slds-bell---axr2","bkAnim":"slds-bkAnim--GQ1mY","navBounceIn":"slds-navBounceIn--VZz-3","error-pulse":"slds-error-pulse--2jLsa","success-pulse":"slds-success-pulse--jQo3Q","warning-pulse":"slds-warning-pulse--1ByS_","dotsBounceBefore-extraExtraSmall":"slds-dotsBounceBefore-extraExtraSmall--1dBYq","dotsBounceAfter-extraExtraSmall":"slds-dotsBounceAfter-extraExtraSmall--21dGY","dotsBounceBefore-extraSmall":"slds-dotsBounceBefore-extraSmall--3I80G","dotsBounceAfter-extraSmall":"slds-dotsBounceAfter-extraSmall--27P7n","dotsBounceBefore-small":"slds-dotsBounceBefore-small--1J7sN","dotsBounceAfter-small":"slds-dotsBounceAfter-small--3vaHF","dotsBounceBefore-medium":"slds-dotsBounceBefore-medium--GQ-SL","dotsBounceAfter-medium":"slds-dotsBounceAfter-medium--1HbPJ","dotsBounceBefore-large":"slds-dotsBounceBefore-large--3VdWi","dotsBounceAfter-large":"slds-dotsBounceAfter-large--3alQ3"};

/***/ }),

/***/ "9CHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CqjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"timelineSection":"styles-timelineSection--sLu2v","timelineComponentButton":"styles-timelineComponentButton--3mc1I","timelineComponentButtonSelected":"styles-timelineComponentButtonSelected--FppBS","timelineRow":"styles-timelineRow--1yztx","timeline":"styles-timeline--AFItT","timelineHeader":"styles-timelineHeader--36qc1","componentsPanel":"styles-componentsPanel--JEOb8","label":"styles-label--1vXo9","propertiesPanel":"styles-propertiesPanel--Hp_W4","playhead":"styles-playhead--3cp4x"};

/***/ }),

/***/ "DRnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bar":"styles-bar--3BK7E"};

/***/ }),

/***/ "EAxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/BackgroundMock/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

// import styles from './styles.scss';

var imageMap = {
  1: "path/to/img",
  2: "path/to/img",
  3: "path/to/img",
  4: "path/to/img",
  5: "path/to/img",
  6: "path/to/img",
  7: "path/to/img",
  8: "path/to/img"
};

function BackgroundMock(_ref) {
  var currentMode = _ref.currentMode;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imageMap[currentMode] });
}

/* harmony default export */ var BackgroundMock_defaultExport = (BackgroundMock);
// CONCATENATED MODULE: ./src/components/App/index.js
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(App___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Canvas__ = __webpack_require__("p5Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__("9CHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      currentMode: 'animating' // "ghosting", "comparison"
    };
    return _this;
  }

  _createClass(App, [{
    key: 'handleModeChange',
    value: function handleModeChange(mode) {
      this.setState({
        currentMode: mode
      });
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        currentMode: this.state.currentMode,
        handleModeChange: this.handleModeChange.bind(this)
      };
    }
  }, {
    key: 'renderCanvas',
    value: function renderCanvas(mode) {
      return App___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Canvas__["a" /* default */], { currentMode: mode });
    }
  }, {
    key: 'render',
    value: function render() {
      var currentMode = this.state.currentMode;

      return App___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.renderCanvas(currentMode),
        App___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackgroundMock_defaultExport, { currentMode: currentMode })
      );
    }
  }]);

  return App;
}(App___WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

App_App.propTypes = {
  children: App___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node.isRequired
};

App_App.childContextTypes = {
  currentMode: App___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleModeChange: App___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ var App_defaultExport = (App_App);
// CONCATENATED MODULE: ./src/routes/index.js
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var routes___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(routes___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__ = __webpack_require__("a8tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_IndexRoute__ = __webpack_require__("Raii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_IndexRoute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_IndexRoute__);





// Webpack 2 supports ES2015 `import()` by auto-
// chunking assets. Check out the following for more:
// https://webpack.js.org/guides/migrating/#code-splitting-with-es2015

var importHome = function importHome(nextState, cb) {
  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Gh4p")).then(function (module) {
    return cb(null, module.default);
  }).catch(function (e) {
    throw e;
  });
};

var importTools = function importTools(nextState, cb) {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "d1y8")).then(function (module) {
    return cb(null, module.default);
  }).catch(function (e) {
    throw e;
  });
};

// We use `getComponent` to dynamically load routes.
// https://github.com/reactjs/react-router/blob/master/docs/guides/DynamicRouting.md
var routes = routes___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a,
  { path: '/', component: App_defaultExport },
  routes___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_IndexRoute___default.a, { getComponent: importHome }),
  routes___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Route___default.a, { path: 'tools', getComponent: importTools })
);

// Unfortunately, HMR breaks when we dynamically resolve
// routes so we need to require them here as a workaround.
// https://github.com/gaearon/react-hot-loader/issues/288
if (false) {
  require('../components/Home'); // eslint-disable-line global-require
  require('../components/Tools'); // eslint-disable-line global-require
}

/* harmony default export */ var routes_defaultExport = (routes);
// CONCATENATED MODULE: ./src/client/Root.js
/* harmony import */ var Root___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var Root___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Root___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Router__ = __webpack_require__("+2z7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_Router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_browserHistory__ = __webpack_require__("clLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_browserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_browserHistory__);





// We need a Root component for React Hot Loading.
function Root() {
  return Root___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_Router___default.a, { history: __WEBPACK_IMPORTED_MODULE_2_react_router_lib_browserHistory___default.a, routes: routes_defaultExport });
}

/* harmony default export */ var Root_defaultExport = (Root);
// CONCATENATED MODULE: ./src/client/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__("9mmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__("52Wt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__("TFWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__("MyjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__("qtRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__("THnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__("K0JP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__("NfZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__("dTzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__("+vXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__("MsuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__("dSUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__("ZDXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__("V/H1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__("CVR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__("vmSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__("4ZU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__("yx1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__("SPtU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__("A52B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__("PuTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__("dm+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__("JG34");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__("Rw4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__("9mGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__("bUY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__("mTp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__("y9m4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__("A0n/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__ = __webpack_require__("n12u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__ = __webpack_require__("nRs1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__("jrHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__ = __webpack_require__("EuXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__ = __webpack_require__("F3sI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__ = __webpack_require__("bqOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__ = __webpack_require__("Racj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__ = __webpack_require__("tqSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__ = __webpack_require__("CvWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__ = __webpack_require__("Y1S0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__ = __webpack_require__("Gh7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__ = __webpack_require__("pd+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__ = __webpack_require__("MfeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__ = __webpack_require__("VjuZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__ = __webpack_require__("mJx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__ = __webpack_require__("qwQ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__ = __webpack_require__("beEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__ = __webpack_require__("xMpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__ = __webpack_require__("9vc3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__ = __webpack_require__("WpTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__ = __webpack_require__("U6qc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__ = __webpack_require__("No4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__ = __webpack_require__("WgSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__ = __webpack_require__("yuXV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__ = __webpack_require__("XtiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__("A1ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__ = __webpack_require__("LG56");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__ = __webpack_require__("Stuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__("aJ2J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__("WiIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__ = __webpack_require__("v2lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__ = __webpack_require__("7Jvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__ = __webpack_require__("lyhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__ = __webpack_require__("kBOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__ = __webpack_require__("xONB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__ = __webpack_require__("LlNE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__ = __webpack_require__("9xIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__ = __webpack_require__("m6Yj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__ = __webpack_require__("wrs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__ = __webpack_require__("Lqg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__ = __webpack_require__("pWGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__ = __webpack_require__("1ip3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__ = __webpack_require__("N4KQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__ = __webpack_require__("Hl+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__ = __webpack_require__("MjHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__ = __webpack_require__("SRCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__ = __webpack_require__("H0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__ = __webpack_require__("gbyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__ = __webpack_require__("YVn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__ = __webpack_require__("FKfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__("zmx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__ = __webpack_require__("smQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__ = __webpack_require__("m8F4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__ = __webpack_require__("v8VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__ = __webpack_require__("dich");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__ = __webpack_require__("fx22");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__ = __webpack_require__("SldL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_react_hot_loader__ = __webpack_require__("rGbO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__shared_styles_slds_scss__ = __webpack_require__("2iKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__shared_styles_slds_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__shared_styles_slds_scss__);






























































































var root = document.querySelector('#root');

var mount = function mount(RootComponent) {
  __WEBPACK_IMPORTED_MODULE_87_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_86_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_88_react_hot_loader__["AppContainer"],
    null,
    __WEBPACK_IMPORTED_MODULE_86_react___default.a.createElement(RootComponent, null)
  ), root);
};

if (false) {
  module.hot.accept('./Root', function () {
    // eslint-disable-next-line global-require,import/newline-after-import
    var RootComponent = require('./Root').default;
    mount(RootComponent);
  });
}

mount(Root_defaultExport);

/***/ }),

/***/ "V/ra":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--lAUlv"};

/***/ }),

/***/ "p5Ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/Menu/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__("tlbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);




function Menu(_ref) {
  var children = _ref.children,
      canvasStyles = _ref.canvasStyles,
      comparison = _ref.comparison,
      ghostingLevel = _ref.ghostingLevel,
      itemCount = _ref.itemCount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(!ghostingLevel && 'slds-align_absolute-center', __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.container, ghostingLevel && __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.ghosted, comparison && __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a['comparison-' + comparison]) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.wrapper, ghostingLevel && __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.ghosted) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a("slds-dropdown-trigger slds-dropdown-trigger_click slds-is-open") },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'slds-button slds-button_icon slds-button_icon-border-filled', 'aria-haspopup': 'true', title: 'Show More' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'svg',
            { className: 'slds-button__icon', 'aria-hidden': 'true' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '/icons/utility-sprite/svg/symbols.svg#down' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'slds-assistive-text' },
            'Show More'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'slds-dropdown slds-dropdown_right', style: canvasStyles },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'slds-dropdown__list', role: 'menu', 'aria-label': 'Show More' },
            children
          )
        )
      )
    )
  );
}

/* harmony default export */ var Menu_defaultExport = (Menu);
// CONCATENATED MODULE: ./src/components/MenuItem/index.js
/* harmony import */ var MenuItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MenuItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MenuItem___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var MenuItem___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(MenuItem___WEBPACK_IMPORTED_MODULE_1_classnames__);



// import styles from './styles.scss';


function MenuItem(_ref) {
  var canvasStyles = _ref.canvasStyles,
      isHidden = _ref.isHidden,
      label = _ref.label;

  return MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: MenuItem___WEBPACK_IMPORTED_MODULE_1_classnames___default.a('slds-dropdown__item', { 'slds-hidden': isHidden }),
      role: 'presentation',
      style: canvasStyles },
    MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: 'javascript:void(0);', role: 'menuitem', tabIndex: '0' },
      MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'slds-truncate', title: "Menu Item ${label" },
        MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { className: 'slds-icon slds-icon_x-small slds-icon-text-default slds-m-right_x-small', 'aria-hidden': 'true' },
          MenuItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: '/icons/utility-sprite/svg/symbols.svg#user' })
        ),
        'Menu Item ',
        label
      )
    )
  );
}

/* harmony default export */ var MenuItem_defaultExport = (MenuItem);
// CONCATENATED MODULE: ./src/components/GhostingPanel/index.js
/* harmony import */ var GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__("1TJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var GhostingPanel = function (_React$Component) {
  _inherits(GhostingPanel, _React$Component);

  function GhostingPanel() {
    _classCallCheck(this, GhostingPanel);

    return _possibleConstructorReturn(this, (GhostingPanel.__proto__ || Object.getPrototypeOf(GhostingPanel)).apply(this, arguments));
  }

  _createClass(GhostingPanel, [{
    key: 'render',
    value: function render() {
      var _context = this.context,
          currentMode = _context.currentMode,
          handleModeChange = _context.handleModeChange;

      return GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'slds-p-around_medium' },
        GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'slds-form-element' },
          GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: 'slds-checkbox_toggle slds-grid' },
            GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'slds-form-element__label slds-m-bottom_none' },
              'Ghosting Mode'
            ),
            GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              onChange: function onChange(e) {
                return handleModeChange(e.target.checked ? "ghosting" : "animating");
              },
              type: 'checkbox',
              checked: currentMode === "ghosting",
              name: 'ghosting-toggle',
              value: 'ghosting-toggle',
              'aria-describedby': 'ghosting-toggle'
            }),
            GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { id: 'ghosting-toggle', className: 'slds-checkbox_faux_container', 'aria-live': 'assertive' },
              GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'slds-checkbox_faux' }),
              GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'slds-checkbox_on' },
                'Enabled'
              ),
              GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'slds-checkbox_off' },
                'Disabled'
              )
            )
          )
        )
      );
    }
  }]);

  return GhostingPanel;
}(GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

GhostingPanel.contextTypes = {
  currentMode: GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleModeChange: GhostingPanel___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ var GhostingPanel_defaultExport = (GhostingPanel);
// CONCATENATED MODULE: ./src/components/ComparisonPanel/index.js
/* harmony import */ var ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ComparisonPanel___WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__("/MJf");
/* harmony import */ var ComparisonPanel___WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(ComparisonPanel___WEBPACK_IMPORTED_MODULE_1__styles_scss__);
var ComparisonPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ComparisonPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ComparisonPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ComparisonPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ComparisonPanel = function (_React$Component) {
  ComparisonPanel__inherits(ComparisonPanel, _React$Component);

  function ComparisonPanel() {
    ComparisonPanel__classCallCheck(this, ComparisonPanel);

    return ComparisonPanel__possibleConstructorReturn(this, (ComparisonPanel.__proto__ || Object.getPrototypeOf(ComparisonPanel)).apply(this, arguments));
  }

  ComparisonPanel__createClass(ComparisonPanel, [{
    key: 'render',
    value: function render() {
      var _context = this.context,
          currentMode = _context.currentMode,
          handleModeChange = _context.handleModeChange;

      return ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'slds-p-around_medium' },
        ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'slds-form-element' },
          ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: 'slds-checkbox_toggle slds-grid' },
            ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'slds-form-element__label slds-m-bottom_none' },
              'Before / After'
            ),
            ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              onChange: function onChange(e) {
                return handleModeChange(e.target.checked ? "comparison" : "animating");
              },
              type: 'checkbox',
              checked: currentMode === "comparison",
              name: 'comparison-toggle',
              value: 'comparison-toggle',
              'aria-describedby': 'comparison-toggle'
            }),
            ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { id: 'comparison-toggle', className: 'slds-checkbox_faux_container', 'aria-live': 'assertive' },
              ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'slds-checkbox_faux' }),
              ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'slds-checkbox_on' },
                'Enabled'
              ),
              ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'slds-checkbox_off' },
                'Disabled'
              )
            )
          )
        )
      );
    }
  }]);

  return ComparisonPanel;
}(ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ComparisonPanel.contextTypes = {
  currentMode: ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  handleModeChange: ComparisonPanel___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};

/* harmony default export */ var ComparisonPanel_defaultExport = (ComparisonPanel);
// CONCATENATED MODULE: ./src/components/StageGhosting/index.js
/* harmony import */ var StageGhosting___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(StageGhosting___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__("/g6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);






function StageGhosting(_ref) {
  var children = _ref.children;

  var renderGhostedMenu = function renderGhostedMenu(level) {
    return StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Menu_defaultExport,
      { itemCount: "0", ghostingLevel: level },
      StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 1", label: "Button 1" }),
      StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 2", label: "Button 2" }),
      StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 3", label: "Button 3" })
    );
  };

  return StageGhosting___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.stage, "slds-align_absolute-center") },
    [5, 4, 3, 2, 1].map(function (level) {
      return renderGhostedMenu(level);
    })
  );
}

/* harmony default export */ var StageGhosting_defaultExport = (StageGhosting);
// CONCATENATED MODULE: ./src/components/StageComparison/index.js
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(StageComparison___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(StageComparison___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__("V/ra");
/* harmony import */ var StageComparison___WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(StageComparison___WEBPACK_IMPORTED_MODULE_4__styles_scss__);






function StageComparison(_ref) {
  var children = _ref.children;

  return StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "slds-grid slds-gutters", style: { height: "100%" } },
    StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "slds-col slds-border_right" },
      StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "slds-text-title_caps" },
        "Before:"
      ),
      StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: StageComparison___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(StageComparison___WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.stage, "slds-align_absolute-center") },
        StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Menu_defaultExport,
          { comparison: "before" },
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 1", label: "Button 1" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 2", label: "Button 2" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 3", label: "Button 3" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 4", label: "Button 4" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 5", label: "Button 5" })
        )
      )
    ),
    StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "slds-col" },
      StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "slds-text-title_caps" },
        "After:"
      ),
      StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: StageComparison___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(StageComparison___WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.stage, "slds-align_absolute-center") },
        StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Menu_defaultExport,
          { comparison: "after" },
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 1", label: "Button 1" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 2", label: "Button 2" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 3", label: "Button 3" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 4", label: "Button 4" }),
          StageComparison___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { key: "Button 5", label: "Button 5" })
        )
      )
    )
  );
}

/* harmony default export */ var StageComparison_defaultExport = (StageComparison);
// CONCATENATED MODULE: ./src/components/Stage/index.js
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Stage___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Stage___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__("0Bm2");
/* harmony import */ var Stage___WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(Stage___WEBPACK_IMPORTED_MODULE_2__styles_scss__);




function Stage(_ref) {
  var children = _ref.children;

  return Stage___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: Stage___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(Stage___WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.stage) },
    children
  );
}

/* harmony default export */ var Stage_defaultExport = (Stage);
// CONCATENATED MODULE: ./src/components/TimelineBar/index.js
/* harmony import */ var TimelineBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var TimelineBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TimelineBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TimelineBar___WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__("DRnN");
/* harmony import */ var TimelineBar___WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(TimelineBar___WEBPACK_IMPORTED_MODULE_1__styles_scss__);



function TimelineBar(_ref) {
  var duration = _ref.duration,
      label = _ref.label,
      onHandleClick = _ref.onHandleClick;

  return TimelineBar___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      className: TimelineBar___WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.bar,
      style: { width: duration * 1000 },
      title: "Timeline: " + label,
      onClick: onHandleClick
    },
    label
  );
}

/* harmony default export */ var TimelineBar_defaultExport = (TimelineBar);
// CONCATENATED MODULE: ./src/components/Canvas/index.js
/* harmony import */ var Canvas___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var Canvas___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Canvas___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__("CqjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
var Canvas__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function Canvas__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Canvas__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Canvas__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Canvas_Canvas = function (_React$Component) {
  Canvas__inherits(Canvas, _React$Component);

  function Canvas(props) {
    Canvas__classCallCheck(this, Canvas);

    var _this = Canvas__possibleConstructorReturn(this, (Canvas.__proto__ || Object.getPrototypeOf(Canvas)).call(this, props));

    var initialProps = {
      property: "opacity",
      duration: 0.2,
      initialValue: 1,
      finalValue: 1,
      value: 1,
      ease: "ease-in",
      delay: 0
    };

    _this.state = {
      playHeadValue: 0,
      componentProps: [],
      componentsAdded: 0,
      initialProps: JSON.parse(JSON.stringify(initialProps)),
      selectedComponent: 0,
      durationValues: [0.2, 0.3, 0.5, 1],
      easeValues: ["ease-in", "ease-out", "ease-in-out"],
      properties: ['max-height', 'height', 'opacity']
    };
    return _this;
  }

  Canvas__createClass(Canvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animate();
    }
  }, {
    key: "getTotalDuration",
    value: function getTotalDuration() {
      return Math.max.apply(Math, _toConsumableArray(this.state.componentProps.map(function (p) {
        return p.duration * 1000 + p.delay * 1000;
      })));
    }
  }, {
    key: "modifyProp",
    value: function modifyProp(i, property, value) {
      var newArr = this.state.componentProps;
      var newProps = newArr[i];
      newProps[property] = value;
      newArr.splice(i, 1, newProps);
      this.setState({ componentProps: newArr });
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this2 = this;

      this.state.componentProps.forEach(function (c, i) {
        _this2.modifyProp(i, 'value', c.finalValue);
        _this2.setState({
          playHeadValue: _this2.getTotalDuration() / 1000 * 500
        });
      });

      setTimeout(function () {
        _this2.state.componentProps.forEach(function (c, i) {
          _this2.modifyProp(i, 'value', c.initialValue);
          _this2.setState({
            playHeadValue: 0
          });
        });

        setTimeout(function () {
          _this2.animate();
        }, 500);
      }, this.getTotalDuration() + 1000);
    }
  }, {
    key: "getDurationToken",
    value: function getDurationToken(v) {
      switch (v) {
        case 1:
          return 'speed-very-slow';
        case 0.5:
          return 'speed-slow';
        case 0.3:
          return 'speed-fast';
        case 0.2:
          return 'speed-very-fast';
        default:
          return 'speed-very-fast';
      }
    }
  }, {
    key: "renderPropMenu",
    value: function renderPropMenu() {
      var _this3 = this;

      var comp = this.state.selectedComponent;
      var props = this.state.componentProps[comp];

      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.propertiesPanel },
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { className: "slds-p-top_medium slds-p-left_medium", style: { fontSize: 10 } },
          "PROPERTIES FOR ",
          this.getNameForComponent(this.state.selectedComponent).toUpperCase()
        ),
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "slds-p-around_medium", style: { display: 'flex' } },
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: 'flex', flexDirection: 'column' } },
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Property"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                style: { margin: 5 },
                value: props.property,
                onChange: function onChange(e) {
                  return _this3.modifyProp(comp, 'property', e.target.value);
                }
              },
              this.state.properties.map(function (v) {
                return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { value: v },
                  v
                );
              })
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Inital Value"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text",
              style: { margin: 5 },
              value: props.initialValue,
              onChange: function onChange(v) {
                return _this3.modifyProp(comp, 'initialValue', v.target.value);
              } }),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Final Value"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text",
              style: { margin: 5 },
              value: props.finalValue,
              onChange: function onChange(v) {
                return _this3.modifyProp(comp, 'finalValue', v.target.value);
              } })
          ),
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: 'flex', flexDirection: 'column' } },
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Speed"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                style: { margin: 5 },
                value: props.duration,
                onChange: function onChange(e) {
                  return _this3.modifyProp(comp, 'duration', e.target.value);
                }
              },
              this.state.durationValues.map(function (v) {
                return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { value: v },
                  _this3.getDurationToken(v)
                );
              })
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Delay"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "text",
              style: { margin: 5 },
              value: props.delay,
              onChange: function onChange(v) {
                return _this3.modifyProp(comp, 'delay', v.target.value);
              } }),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.label },
              "Ease"
            ),
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                style: { margin: 5 },
                value: props.ease,
                onChange: function onChange(e) {
                  return _this3.modifyProp(comp, 'ease', e.target.value);
                }
              },
              this.state.easeValues.map(function (v) {
                return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { value: v },
                  v
                );
              })
            )
          )
        ),
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "slds-p-horizontal_medium slds-m-top_medium" },
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GhostingPanel_defaultExport, null)
        ),
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "slds-p-horizontal_medium slds-m-top_medium" },
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComparisonPanel_defaultExport, null)
        )
      );
    }
  }, {
    key: "changeSelectedComponent",
    value: function changeSelectedComponent(selectedComponent) {
      this.setState({ selectedComponent: selectedComponent });
    }
  }, {
    key: "addNewComponent",
    value: function addNewComponent() {
      var newArr = this.state.componentProps;
      newArr.push(JSON.parse(JSON.stringify(this.state.initialProps)));
      this.setState({ componentProps: newArr });
    }
  }, {
    key: "renderComponentPanel",
    value: function renderComponentPanel() {
      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.componentsPanel },
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { className: "slds-p-top_medium slds-p-left_medium", style: { fontSize: 10 } },
          "COMPONENTS"
        ),
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: "slds-p-around_medium" },
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { onClick: this.addNewComponent.bind(this), src: "/menuButton.svg" }),
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "slds-p-top_medium", onClick: this.addNewComponent.bind(this), src: "/listItem.svg" }),
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "slds-p-top_medium", onClick: this.addNewComponent.bind(this), src: "/modal.svg" })
        )
      );
    }
  }, {
    key: "renderButton",
    value: function renderButton(i) {
      var props = this.state.componentProps[i];

      var style = {
        height: props.property === 'height' ? props.value : null,
        maxHeight: props.property === 'max-height' ? props.value : null,
        opacity: props.property === 'opacity' ? props.value : 1,
        transition: this.compileTransition(i)

        // {/* to smoothly animate things, we might need the menu button items already in the menu, but just have them hidden at first */}
        // {/* taking out isHidden={this.state.componentsAdded <= 1} attribute for now */}

      };return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem_defaultExport, { isHidden: false, key: "Button " + i, canvasStyles: style, label: "Button " + i });
    }
  }, {
    key: "getNameForComponent",
    value: function getNameForComponent(i) {
      return i === 0 ? 'Menu' : "Button " + i;
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var numberOfComps = this.state.componentProps.length;
      if (numberOfComps === 0) return null;
      var menuProps = this.state.componentProps[0];
      var style = {
        overflow: 'hidden',
        height: menuProps.property === 'height' ? menuProps.value : menuProps === 'max-height' ? null : 200,
        maxHeight: menuProps.property === 'max-height' ? menuProps.value : null,
        opacity: menuProps.property === 'opacity' ? menuProps.value : 1,
        transition: this.compileTransition(0)
      };

      return numberOfComps > 0 && Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Menu_defaultExport,
        { itemCount: numberOfComps, canvasStyles: style },
        this.state.componentProps.slice(1).map(function (_, i) {
          return _this4.renderButton(i + 1);
        })
      );
    }
  }, {
    key: "setSelectedComponent",
    value: function setSelectedComponent(selectedComponent) {
      this.setState({
        selectedComponent: selectedComponent
      });
    }
  }, {
    key: "renderTimelineSection",
    value: function renderTimelineSection(props, i) {
      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { key: i,
        className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timelineSection,
        style: { width: props.duration * 500, marginLeft: props.delay * 500 } });
    }
  }, {
    key: "renderTimelineCompButton",
    value: function renderTimelineCompButton(i) {
      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: this.state.selectedComponent === i ? __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timelineComponentButtonSelected : __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timelineComponentButton,
          onClick: this.setSelectedComponent.bind(this, i) },
        this.getNameForComponent(i)
      );
    }
  }, {
    key: "renderTimelineHeader",
    value: function renderTimelineHeader() {
      var headerSectionArry = [];
      for (var time = 0; time < 3; time += 0.1) {
        headerSectionArry.push(time);
      }

      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timelineHeader },
        headerSectionArry.map(function (time) {
          return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { width: 50, flex: 'none' } },
            time.toFixed(1),
            "s"
          );
        })
      );
    }
  }, {
    key: "getPlayheadTransition",
    value: function getPlayheadTransition() {
      return this.state.playHeadValue === this.getTotalDuration() / 1000 * 500 ? "left linear " + this.getTotalDuration() / 1000 + "s" : null;
    }
  }, {
    key: "renderTimeline",
    value: function renderTimeline() {
      var _this5 = this;

      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timeline },
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.playhead, style: { left: this.state.playHeadValue + 200, transition: this.getPlayheadTransition() } }),
        this.renderTimelineHeader(),
        this.state.componentProps.map(function (props, i) {
          return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.timelineRow },
            _this5.renderTimelineCompButton(i),
            _this5.renderTimelineSection(props, i)
          );
        })
      );
    }
  }, {
    key: "playheadTransition",
    value: function playheadTransition() {
      return this.state.playhead === props.value ? property + " " + props.duration + "s " + props.ease + " " + props.delay + "s" : null;
    }
  }, {
    key: "compileTransition",
    value: function compileTransition(comp) {
      var props = this.state.componentProps[comp];
      var property = this.state.componentProps[comp].property;
      return props.finalValue === props.value ? property + " " + props.duration + "s " + props.ease + " " + props.delay + "s" : null;
    }
  }, {
    key: "render",
    value: function render() {
      return Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: 'flex', borderBottom: '1px #979797 solid' } },
        this.renderComponentPanel(),
        Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: 'flex', borderBottom: '1px #979797 solid' } },
            Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Stage_defaultExport,
              null,
              this.context.currentMode === "comparison" && Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StageComparison_defaultExport, null),
              this.context.currentMode === "ghosting" && Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StageGhosting_defaultExport, null),
              this.context.currentMode === "animating" && this.renderMenu()
            ),
            this.state.componentProps.length > 0 ? this.renderPropMenu() : null
          ),
          this.renderTimeline()
        )
      );
    }
  }]);

  return Canvas;
}(Canvas___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Canvas_Canvas.contextTypes = {
  currentMode: Canvas___WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (Canvas_Canvas);

/***/ }),

/***/ "tlbl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--25c0J","ghosted":"styles-ghosted--1hu3r","wrapper":"styles-wrapper--3Q86O","comparison-before":"styles-comparison-before--1JQKt","comparison-after":"styles-comparison-after--2tDjI"};

/***/ })

},["EAxn"]);


// WEBPACK FOOTER //
// main.js